/**
 * Skills section that shows all of the technologies that I use.
 * Handles the nice hover function in conjunction with the styles
 */
import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';

import { SkillIconDiv, SkillDescriptionDiv } from '../../../styles/sectionStyles/AboutSectionStyles';

import skillData from './SkillData';


export default function Skills () {
  const [hovered, setHovered] = useState(-1);

  return (
    <Grid container
      direction="row"
      justifyContent="center"
      alignItems="center"
    >
      {skillData.map((skill, key) => {
        return (
          <Grid item key={key}>
            <SkillIconDiv 
              hoveredOpacity={hovered === key ? 1 : hovered === -1 ? 1 : 0.2} 
              skillColor={skill.skillThemeColor} 
              onMouseEnter={(e) => setHovered(key)} 
              onMouseLeave={(e) => setHovered(-1)}
            >
              {skill.element} 
              <div style={{textAlign: 'center', fontSize: '10.5px'}}>
                {skill.label}
                <SkillDescriptionDiv>
                  {skill.description}
                </SkillDescriptionDiv>
              </div>
            </SkillIconDiv>
            
          </Grid>)
      })}
    </Grid>
  );
}